import { useEffect, useState } from "react";

import { Checkbox, TextField} from "@king-ict/eupisi-ui/components";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router";

import { getGroupById } from "../../api/Faq/FaqApi";
import { ContentArea, FormCard,ToolbarTop  } from "../../components";
import { Group, FaqApplicationDisplay } from "../../models/Faq";
import { faqGroupEditUrl, faqGroupListRoute } from "../../routes/routes";
import styles from "../SchoolYear/SchoolYearList.module.scss";

export function FaqGroupDetails() {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();
  const history = useHistory();

  const createDefaultItem = (): Group => {
    return {
      id: 0,
      name: "",
      faqApplicationDisplayId: 1,
      status: true,
    };
  };
  const [group, setGroup] = useState<Group>(createDefaultItem());

  useEffect(() => {
    (async () => {
        if (!isNaN(+id) && +id > 0) {
          var result  = (await getGroupById(+id));
          if (result) {
            setGroup(result);
          }
        }
    })();
  }, [id]);

  const goBack = () => {
    history.push(faqGroupListRoute);
  };

  const handleBackClicked = () => {
      goBack();
  };

  const handleEditClicked = () => {
    history.push(faqGroupEditUrl(+id));
  };

  return (
    <ContentArea>
      <ToolbarTop
        showEdit="show"
        showBack="show"
        onClickEdit={handleEditClicked}
        onClickBack={handleBackClicked}
        pageTitle={t("common.faq.groupPageName")}
      ></ToolbarTop>
      <FormCard>
        <Row className={styles.rowPaddingMedium}>
          <Col md={12}>
            <TextField
              label={t("common.faq.name")}
              name={"group.name"}
              value={group.name}
              readonly
              plaintext
            />
          </Col>
        </Row>
        <Row className={styles.rowPaddingMedium}>
          <Col md={12}>
            <TextField
              label={t("common.faq.applicationDisplay")}
              name={"group.faqApplicationDisplayId"}
              value={t("common.faq.faqApplicationDisplay." + FaqApplicationDisplay[group.faqApplicationDisplayId]) as string}
              readonly
              plaintext
              />
              
          </Col>
        </Row>
        <Row className={styles.rowPaddingMedium}>
          <Col md={12}>
          <Checkbox
              label={t("common.faq.active")}
              name={"group.status"}
              checked={group.status}
              plaintext
            />
          </Col>
        </Row>
      </FormCard>
    </ContentArea>
  );
}


